import { api } from '@mbfab/client-api'
import { isNull, isSome } from '@mbfab/shared'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { CenteredLoading } from '@/components/app/centered-loading'
import { GraphqlErrorPanel } from '@/components/app/graphql-error-panel'
import { PlanConfirmWorkspace } from '@/components/screens/onboarding/plan-confirm-workspace'
import { userFacingErrorMessage } from '@/lib/user-facing-error-message'

export const Route = createFileRoute('/t/$tenant_id/plan/confirm')({
  component: Page,
})

function Page() {
  const { tenant_id: tenantId } = Route.useParams()
  const navigate = useNavigate()
  const client = api.useClient()
  const detailQuery = api.useFetchMyTenantDetailQuery()

  if (isNull(detailQuery.data)) {
    if (isSome(detailQuery.error)) {
      return (
        <GraphqlErrorPanel
          error={detailQuery.error}
          subject="プラン情報"
          onRetry={() => {
            void detailQuery.refetch()
          }}
        />
      )
    }
    return <CenteredLoading message="読み込み中..." />
  }

  const tenant = detailQuery.data.me.tenant
  const tenantPlan = tenant.tenantPlan

  return (
    <PlanConfirmWorkspace
      tenantName={tenant.name}
      quoteNumber={tenantPlan?.quoteNumber ?? null}
      serviceTerms={tenantPlan?.plan.serviceTerms ?? null}
      onAgree={async () => {
        try {
          await client.agreeToServiceTerms({})
        } catch (error) {
          return {
            ok: false,
            message: userFacingErrorMessage(
              error,
              '利用規約に同意できませんでした。お手数ですが、管理者にお問い合わせください。',
            ),
          }
        }
        void navigate({
          to: '/t/$tenant_id/plan/complete',
          params: { tenant_id: tenantId },
        })
        return { ok: true }
      }}
    />
  )
}
